import logoWhite from "../assets/images/logo_white.png";
import { logout } from "../api/auth";

import "../assets/css/product.scss";

function Footer() {
  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <h2 className="footer-title">
          {/* <img src={logoWhite} alt="" /> */}
          키즈다
        </h2>

        <div className="footer-info">
          <p>
            <strong>주식회사 위고컴퍼니</strong> | 대표: 김영기 |
            사업자등록번호: 339-87-00990
          </p>
          <p>경기도 화성시 동탄대로5길 21 4층 E420-A26호 (송동, 라크몽)</p>
          <p>대표전화: 02-3288-3455 | 청소년보호책임자: 김준영</p>
          <p>통신판매업등록번호: 2021-화성동탄-0946 | 제호: 키즈다</p>
        </div>

        <div className="footer-links">
          <a href="/application/service" target="_blank" rel="noreferrer">
            이용약관
          </a>
          <span>|</span>
          <a href="/application/privacy" target="_blank" rel="noreferrer">
            개인정보처리방침
          </a>
          <span>|</span>
          <button
            onClick={handleLogout}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#ffffff",
              padding: 0,
              font: "inherit",
            }}
          >
            로그아웃
          </button>
        </div>

        <hr className="footer-line" />

        <div className="footer-copy">
          Copyright © 키즈다 All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
